import { useState, useRef, useEffect, useMemo } from "react"
import { Col, Row } from "antd"
import { useSelector, useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
// context
import { useTheme } from "context/AntdThemeContext"
// ui
import { Card } from "ui/AdventureModeSelect/Card"
import { ActionButtons } from "ui/ActionButtons"
// constants

import { themes } from "constants/theme"
import { updateUser } from "store/user"
import { SettingsTitle } from "pagesV2/pro/Settings/ProSettings/SettingsTitle"
import { toaster } from "components/common/Toast"

const modeOptions = [{ type: themes.sportsman }, { type: themes.sportswoman }]

export const ModePreferences = () => {
  const { t } = useTranslation()
  const { theme, switchTheme, saveThemeToStorage } = useTheme()
  const dispatch = useDispatch()
  const { adventure_mode, loading } = useSelector((state) => state.user)
  const [mode, setMode] = useState(adventure_mode || theme)
  const prevModeRef = useRef(adventure_mode || theme)

  // Keep mode in sync with adventure_mode redux value
  useEffect(() => {
    if (adventure_mode && adventure_mode !== mode) {
      setMode(adventure_mode)
      prevModeRef.current = adventure_mode
    }
  }, [adventure_mode])

  useEffect(() => {
    if (theme && theme !== mode) {
      setMode(theme)
      prevModeRef.current = theme
    }
  }, [theme])

  const onSelect = (theme) => {
    setMode(theme)
    switchTheme(theme)
  }

  // Determine if mode has changed from the original value
  const isDirty = useMemo(() => prevModeRef.current !== mode, [mode])
  const handleCancel = () => {
    if (isDirty) {
      setMode(prevModeRef.current)
      switchTheme(prevModeRef.current)
    }
  }

  const submitAdventureMode = () => {
    dispatch(updateUser({ adventure_mode: mode })).then((result) => {
      toaster.success(result?.message)
      saveThemeToStorage(mode)
      prevModeRef.current = mode // update reference after save
    })
  }

  return (
    <div className="flex-column">
      <div className="flex-column">
        <SettingsTitle title={t("select_adventure_mode.title")} subTitle={t("select_adventure_mode.subtitle")} />
        <div className="justify-center pt-4xl">
          <Row gutter={{ xs: 10, md: 24 }} className="w-full">
            {modeOptions.map(({ type }) => (
              <Col span={12} key={type}>
                <Card type={type} bordered={false} selected={mode === type} onSelect={() => onSelect(type)} isRadioButton />
              </Col>
            ))}
          </Row>
        </div>

        <div className="flex gap-s mt-4xl">
          <ActionButtons onCancelClick={handleCancel} onSaveClick={submitAdventureMode} disabled={loading || !isDirty} />
        </div>
      </div>
    </div>
  )
}
